import dateFormat from 'dateformat';
import history from '../../../../../history';

const style = {
  tableText: {
    fontWeight: '600',
    fontSize: '12px',
    fontFamily: 'Nunito',
    color: '#435963',
  },
};

const dateFormatter = (column, defaultValue = '--') => {
  if (!column) {
    return <span>{defaultValue}</span>;
  }
  return <span>{dateFormat(new Date(column), 'ddd, mmmm dS, yyyy')}</span>;
};

const getProfessionalLink = (professional) => {
  if (!professional) {
    return <span>--</span>;
  }

  const userUrl = `/user/hygienist/${professional.id}`;

  return (
    <a
      href={userUrl}
      style={{ fontSize: 12, cursor: 'pointer', textDecoration: 'underline', ...style.tableText }}
      rel="noreferrer"
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        history.push(userUrl);
      }}
    >
      {professional.fullName}
    </a>
  );
};

export const onsiteInterviewColumns = () => [
  {
    selector: (row) => row.jobStatus,
    name: 'Status',
    cell: (row) => (
      <span style={{ textTransform: 'capitalize' }}>{row.jobStatus || '--'}</span>
    ),
    style: style.tableText,
    sortable: true,
    sortField: 'status',
    width: '130px',
  },
  {
    selector: (row) => row.localDate,
    name: 'Date',
    cell: (row) => <span>{row.localDate || '--'}</span>,
    style: style.tableText,
    sortable: true,
    sortField: 'date',
    width: '232px',
  },
  {
    selector: (row) => row.localStartTime,
    name: 'Start Time',
    cell: (row) => <span>{row.localStartTime || '--'}</span>,
    style: style.tableText,
    width: '104px',
  },
  {
    selector: (row) => row.localEndTime,
    name: 'End Time',
    cell: (row) => <span>{row.localEndTime || '--'}</span>,
    style: style.tableText,
    width: '128px',
  },
  {
    selector: (row) => row.professional?.fullName,
    name: 'Professional',
    cell: (row) => getProfessionalLink(row.professional),
    style: style.tableText,
    width: '212px',
  },
  {
    selector: (row) => row.jobFilledDatetime,
    name: 'Fill Date',
    cell: (row) => dateFormatter(row.jobFilledDatetime),
    style: style.tableText,
    sortable: false,
    width: '226px',
  },
  {
    selector: (row) => row.createdAt,
    name: 'Created At',
    cell: (row) => dateFormatter(row.createdAt),
    style: style.tableText,
    sortable: true,
    sortField: 'created',
    width: '224px',
  },
];

const getRowStyle = (row) => {
  const status = row?.jobStatus?.toLowerCase();

  if (status === 'cancelled' || status === 'expired') {
    return { backgroundColor: '#F8B5B5' };
  }
  if (status === 'open' || status === 'pending' || status === 'counter') {
    return { backgroundColor: '#FDFFC9' };
  }
  if (status === 'filled' || status === 'pay-out') {
    return { backgroundColor: '#C1F5B9' };
  }
  if (status === 'complete') {
    return { backgroundColor: '#C0E9F2' };
  }
  return null;
};

export const onsiteInterviewConditionalRowStyles = [
  {
    when: (row) => !!getRowStyle(row),
    style: (row) => getRowStyle(row),
  },
];
